import { render } from "./OrganizationProfile.vue?vue&type=template&id=be33c57a&scoped=true"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-be33c57a"

export default script